import 'babel-polyfill';
import React, { Component } from 'react';
import { Admin, Delete, Resource } from 'admin-on-rest';

import './App.css';

import authClient from './authClient';
import sagas from './sagas';
import themeReducer from './themeReducer';
import Login from './Login';
//import MyLayout from './Layout';
import MyLayout from './MyLayout';


import Menu from './Menu';
//import { Dashboard } from './dashboard';
import customRoutes from './routes';
import translations from './i18n';
import { HafkadotList , HafkadotShow} from './components/Hafkadot/hafkadot';

import restClient from './restClient';





class App extends Component {
    componentWillMount() {
     //   this.restoreFetch = fakeRestServer();
    }

    componentWillUnmount() {
    //    this.restoreFetch();
    }

    render() {
        return (
            <Admin
                title="איגוד הסליקה הישראלי - פירוט עסקאות"
                restClient={restClient}
                customReducers={{ theme: themeReducer }}
                customSagas={sagas}
                customRoutes={customRoutes}
                authClient={authClient}
                /*dashboard={Dashboard}*/
                loginPage={Login}
                appLayout={MyLayout}

                menu={Menu}
                messages={translations}
                locale={'he'} 
                
            >
            <Resource name="account" list={HafkadotList} show={HafkadotShow} />
          




            </Admin>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js